import React, { useState, useEffect } from "react";
import "../../assets/styles/admin/quotation.scss";
import Icon from "@mdi/react";
import { mdiPlus } from "@mdi/js";
import SearchField from "../../components/textfield/searchField";
import Button from "../../components/button/Button";
import TableColumn from "../../components/table/tableColumn";
import MainTable from "../../components/table/mainTable";
import HeaderBar from "../../components/header/headerBar";
import Select from "../../components/select/select";
import MainButton from "../../components/button/mainButton";
import EmptyModel from "../../components/modal/emptyModal";
import SelectField from "../../components/select/selectField";
import { Table } from "antd";
import { useHistory } from "react-router-dom";
import NumberFormat from "react-number-format";
import moment from "moment";
import axios from "axios";
const Quotation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [typeId, setTypeId] = useState("");
  const [status, setStatus] = useState("");
  const [dataList, setDataList] = useState<any[]>([]);
  const [searchKeyItem, setSearchKeyItem] = useState<string>("");
  const [selectItem, setSelectItem] = useState<any>({});

  const [selectOptionStatus, setSelectOptionStatus] = useState<string>("");

  const history = useHistory();
  const columns2 = [
    {
      title: "",
      dataIndex: "rowCount",
      width: "5%",
      align: "center" as const,
      render: (text: any, record: any, index: number,) => index + 1,
    },
    {
      title: <>เลขที่ใบเสนอราคา<br />Quotation - NO.</>,
      dataIndex: "code",
      width: "150px",
      align: "center" as const,
      render: (text: any) => <div style={{ textAlign: "left" }}>{text}</div>,
    },
    {
      title: <>ชื่อลูกค้า<br />Name</>,
      dataIndex: "code",
      render: (text: any) => {
        return text;
      },
    },
    {
      title: <>รวมราคาขาย<br />Price Total</>,
      dataIndex: "treatments",
      align: "center" as const,
      width: "120px",
      render: (text: any, record: any) => {
        return (
          <NumberFormat
            value={text.reduce(
              (total: number, item: any) => {
                return (
                  total +
                  Math.round(
                    item.price * item.quantity - item.discount
                  )
                );
              },
              0
            )}
            displayType={"text"}
            thousandSeparator={true}
          />
        )
      },
    },
    {
      title: <>วันที่<br />Date</>,
      dataIndex: "date",
      align: "center" as const,
      width: "120px",
      render: (text: any, record: any) => moment(text).format("DD-MM-YYYY") || ""
    },
    {
      title: <>สถานะ<br />Status</>,
      dataIndex: "status",
      align: "center" as const,
      width: "120px",
      render: (text: any, record: any) => {
        return {
          props: {
            style: {
              height: "50px",
              padding: 0
            }
          },
          children: <div style={{
            display: "flex",
            justifyContent: "center",
            backgroundColor: text
              ? "#5BAEA9"
              : !text
                ? "#E76464"
                : "#FFFFFF",
            height: "100%",
            width: "100%",
            color: "#FFF",
            alignItems: "center",
            textDecorationLine: !text ? "underline" : "",
            pointerEvents: text ? "none" : "auto",
            cursor: !text ? "pointer" : ""
          }}><a
            onClick={() => {
              setIsOpen(true);
              setSelectItem(record);
            }}
          >
              {text ? "Accept" : "Not Accept"}
            </a>
          </div>
        }
      }
    },
    {
      title: <>ดูใบเสนอราคา<br />View</>,
      dataIndex: "_id",
      align: "center" as const,
      width: "120px",
      render: (text: any, record: any) => <MainButton
        title="View"
        width="100px"
        onClick={() => {
          history.push(`/quotation/detail/${text}/print`);
        }}
      />
    }
  ];
  const optionStatus = [
    { value: "true", name: "Accept" },
    { value: "false", name: "Not Accept" },
  ];

  const option = [{ value: "", name: "All" }, { value: "true", name: "Accept" }, { value: "false", name: "Not Accept" }];

  function onClose() {
    setIsOpen(false);
  }
  useEffect(() => {
    getData();
  }, []);
  const searchItem = () => {
    let mockDataList = dataList;
    if (selectOptionStatus !== "")
      mockDataList = dataList.filter( (i :any) => i.status.toString() === selectOptionStatus);
    if (searchKeyItem.length >= 1) {
      let calculateData: any = [];
      for (let i = 0; i < mockDataList.length; i++) {
        if (mockDataList[i]["code"]?.substr(0, searchKeyItem).toUpperCase() === searchKeyItem.toUpperCase()) {
          calculateData.push(mockDataList[i]);
        } else if (mockDataList[i]["code"]?.toUpperCase().indexOf(searchKeyItem.toUpperCase()) > -1) {
          calculateData.push(mockDataList[i]);
        } else if (mockDataList[i]["name"]?.substr(0, searchKeyItem).toUpperCase() === searchKeyItem.toUpperCase()) {
          calculateData.push(mockDataList[i]);
        } else if (mockDataList[i]["name"]?.toUpperCase().indexOf(searchKeyItem.toUpperCase()) > -1) {
          calculateData.push(mockDataList[i]);
        }
      }
      return calculateData;
    } else {
      return mockDataList;
    }
  };
  const getData = () => {
    axios.get(`/quotation`).then((res) => {
      setDataList(res.data?.data);
    });
  }
  const updateStatus = () => {
    axios.patch(`/quotation/updata/status/${selectItem?._id}`, {
      ...selectItem
    }).then((res) => {
      setIsOpen(false)
      getData();
    });
  }
  return (
    <>
      <div>
        <HeaderBar title="QUOTATION" />
        <div style={{ padding: "10px 30px" }}>
          <EmptyModel show={isOpen} onClose={onClose} setStyle={{ height: 'auto' }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "20px 40px",
              }}
            >
              <h4>อัพเดทสถานะ/Status Update</h4>
              <div className="row justify-center  mt-20">
                <div className="select-field col-10">
                  <SelectField
                    title="เลือกสถานะ/Select Status"
                    value={selectItem?.status}
                    option={optionStatus}
                    onChange={(e) => {
                      setSelectItem({ ...selectItem, status: e.target.value });
                    }}
                  />
                </div>
              </div>
              <div className="justify-center mt-20">
                <MainButton
                  className="mg-10"
                  background="#E76464"
                  title="ย้อนกลับ"
                  onClick={() => {
                    setIsOpen(false);
                  }}
                />
                <MainButton
                  className="mg-10"
                  title="ยืนยันรายการ"
                  onClick={() => {
                    updateStatus();
                  }}
                />
              </div>
            </div>
          </EmptyModel>
          <SearchField
            placeholder="Search for customer (CN, Name, Mobile No.)"
            color="#FFFFFF"
            onChange={(e: any) => setSearchKeyItem(e.target.value)}
          />
          <div
            className="email_type"
            style={{
              marginTop: "10px",
              flexWrap: "nowrap",
              alignItems: "center",
              background: "#ffff",
              padding: "0.2rem",
            }}
          >
            <Select title="STATUS :" option={option} onChange={(e : any) => setSelectOptionStatus(e.target.value)}/>
          </div>
          <div className="button-add">
            <MainButton
              title="Create Quote"
              onClick={() => history.push("/quotation/create/")}
            >
              <Icon path={mdiPlus} size="20" color="#FFFFFF" />
            </MainButton>
          </div>
          <div className="ant-table-wrapper-2">
            <Table
              columns={columns2}
              dataSource={searchItem()}
              rowKey="_id"
              bordered
              scroll={{ x: 100 }}
              size="small"
            ></Table>
          </div>
        </div>
      </div>
    </>
  );
};
export default Quotation;
